import React from 'react'
import { LOCALE } from '../../../../constants/activity-constants'
const loc_arg = ['es-AR', 'es-PY', 'es-UY'].includes(LOCALE)
export function getTitleInfo(isMobile) {
  if (loc_arg) {
    return <>¿Ya hacés parte de {isMobile && <br />} NosotrasOnline?</>
  }

  return <>¿Ya haces parte de {isMobile && <br />} NosotrasOnline?</>
}
export function getContentText2() {
  if (loc_arg) {
    return <>Para poder jugar debés</>
  }
  return <>Para poder jugar debes</>
}

export function getButtonText() {
  if (loc_arg) {
    return <>Registrate acá</>
  }
  return <>Regístrate aquí</>
}
